(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["marquee-scroll-section"] && !Shopify.designMode) return;
  try {
    
(function(){
  function buildMarquee(root){
    const wrapper = root.querySelector('.marquee-wrapper');
    const viewport = root.querySelector('.marquee-viewport');
    const track = root.querySelector('.marquee-track');
    let group = root.querySelector('.marquee-group');

    if(!wrapper || !viewport || !track || !group) return;

    const direction = (wrapper.dataset.direction || 'left').toLowerCase();
    const speed = parseInt(wrapper.dataset.speed || '20', 10);
    const mobileSpeed = parseInt(wrapper.dataset.mobileSpeed || speed, 10);
    const desktopSpeed = parseInt(wrapper.dataset.desktopSpeed || speed, 10);

    
    const groups = track.querySelectorAll('.marquee-group');
    groups.forEach((g, idx) => { if(idx > 0) g.remove(); });
    group = track.querySelector('.marquee-group');

    
    const isVertical = (direction === 'up' || direction === 'down');
    viewport.classList.toggle('is-vertical', isVertical);

    
    const isMobile = window.innerWidth <= 767;
    if (isMobile) {
      track.style.setProperty('--mobile-speed', mobileSpeed + 's');
      track.style.removeProperty('--desktop-speed');
    } else {
      track.style.setProperty('--desktop-speed', desktopSpeed + 's');
      track.style.removeProperty('--mobile-speed');
    }

    
    track.style.animationName = 'marquee-' + direction;

    
    const firstItems = Array.from(group.children);
    if(firstItems.length === 0) return;

    
    const viewportSize = isVertical ? viewport.clientHeight : viewport.clientWidth;

    
    if(viewportSize <= 0) return;

    
    
    let guard = 0;
    const maxLoops = 80;

    const measureGroup = () => isVertical ? group.scrollHeight : group.scrollWidth;

    while(measureGroup() < viewportSize && guard < maxLoops){
      firstItems.forEach(item => group.appendChild(item.cloneNode(true)));
      guard++;
    }

    
    const clone = group.cloneNode(true);
    track.appendChild(clone);

    
    
    if (isVertical) {
      
      
      viewport.style.overflow = 'hidden';
    }
  }

  function init(){
    const roots = document.querySelectorAll('[data-marquee-root="true"]');
    roots.forEach(root => buildMarquee(root));
  }

  
  let t = null;
  window.addEventListener('resize', function(){
    clearTimeout(t);
    t = setTimeout(init, 200);
  });

  document.addEventListener('DOMContentLoaded', init);
})();

  } catch(e) { console.error(e); }
})();
})();
